import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FunnelFAQ = ({ product }) => (
  <section className="bg-white">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-32">
          <p data-reveal className="text-sm tracking-[0.2em] uppercase text-[#29ABE2] font-semibold mb-4">
            Straight answers
          </p>
          <h2
            data-reveal
            className="font-heading font-black text-4xl sm:text-5xl tracking-tighter leading-[0.95] text-[#0B132B]"
          >
            The questions people actually ask.
          </h2>
          <p data-reveal className="mt-5 text-base text-[#334155] font-light leading-relaxed max-w-sm">
            No spin. If {product.tag} isn't the right fit, we'll tell you — and point you somewhere better.
          </p>
        </div>
      </div>
      <div className="lg:col-span-8" data-reveal>
        <Accordion type="single" collapsible className="space-y-3" data-testid="funnel-faq">
          {product.funnel.faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="rounded-3xl border border-[#0B132B]/8 bg-[#F9F6F0] px-5 sm:px-7 data-[state=open]:border-[#29ABE2]/40 data-[state=open]:bg-white data-[state=open]:shadow-lg data-[state=open]:shadow-[#0B132B]/5 transition-all duration-300"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 sm:py-6 font-heading font-bold text-base sm:text-lg md:text-xl tracking-tight text-[#0B132B] hover:no-underline gap-4 [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-[#29ABE2]"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-sm sm:text-base text-[#334155] font-light leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
